import {
  IconButton,
  InputAdornment,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { font } from "../../../styles/font";
import { TextFieldMA } from "../../../styles/styledComponents";
import { theme } from "../../../styles/theme";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import validator from "validator";
import { VerifyOtp } from "../verifyOtp";
import { ApplicationContext } from "../../../context/application_ctx";
import {
  resendOtpCall,
  signIn,
  userDetails,
} from "../../../api/controllers/userController";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../../components/snackBar";
import { ButtonCustom } from "../../../components/button";
import { IconBack } from "../../../svgIcons/icons";
import { CompanyProfile } from "../../../components/companyRegistration/companyProfile";
import { SideBanner } from "../../../components/maSideBanner";
import { Subscriptions } from "../../../components/companyRegistration/subscriptions";
import { StripePayment } from "../../../components/companyRegistration/subscriptions/stripePayment";
import { GlobalLoaders } from "../../../components/loaders/globalLoader";

export const Signin = () => {
  const { login, tokenTemp, setTokenTemp, setActiveTab } =
    useContext(ApplicationContext);
  console.log(login);
  const navigate = useNavigate();
  const loginQuery = useMediaQuery("(max-width:800px)");
  const [signInSnack, setSignInSnack] = useState(false);
  const [loaderState, setLoaderState] = useState(false);
  const [loaderStateApi, setLoaderStateApi] = useState(false);
  const [error, setError] = useState("");
  const [visibility, setVisiblity] = useState(false);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [loginNavigation, setLoginNavigation] = useState(0);

  const handleSignin = async () => {
    if (!email) {
      setEmail("");
    }
    if (!password) {
      setPassword("");
    }
    if (
      email &&
      validator.isEmail(email) &&
      password &&
      validator.isStrongPassword(password)
    ) {
      console.log("api call");
      setLoaderStateApi(true);
      try {
        let response = await signIn({
          email,
          password,
        });
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          if (!response.data.isEmailVerified) {
            console.log("entered");
            setLoaderStateApi(false);
            resendOtp()
            setTokenTemp(response.data.token);
            setLoginNavigation(1);
          } else {
            console.log("enteredelse");

            setLoaderStateApi(false);
            setActiveTab(0);
            localStorage.setItem("api-token", response.data.token);
            navigate("/dashboard");
          }
        }
        if (response.status === HttpStatusCode.BadRequest) {
          // setLoaderState(false);

          setError(response.data.message);
          setSignInSnack(true);

          setLoaderStateApi(false);

          setTokenTemp(response.data.token);
          // setLoginNavigation(1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const resendOtp = async (type) => {
    // setLoaderStateOtp(true)
    console.log("enterd");
    try {
      let response = await resendOtpCall(
        {
          email,
        }
        // tokenTemp
      );
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        // setLoaderState(false);
        // setLoaderStateOtp(false)
        // setError(response.data.message);
        // setFpSnack(true);
        // setResendTimeout(true)
        // setTimeout(() => {
        //   setResendTimeout(false)
        // }, 30000);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setLoaderState(false);
        // setError(response.data.message);
        // setFpSnack(true);
        // setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const getDetails = async () => {
      try {
        let response = await userDetails();
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
      }
    };
    getDetails();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  const handleEnter = (e)=>{
    console.log(e.key)
    if(e.key === 'Enter'){
      document.getElementById('enterButton').click()
    }
  }
  return (
    <>
      <Box
        display={"flex"}
        width="100vw"
        height={"100vh"}
        backgroundColor={theme.col_1}
        alignItems="center"
      >
        <SideBanner query={loginQuery} />
        <Box
          position="relative"
          display={"flex"}
          width={loginQuery ? "100%" : "65%"}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          backgroundColor={"white"}
          flexDirection="column"
        >
          {loginNavigation !== 0 ? (
            <Box width="100%">
              <IconButton
                onClick={() =>
                  setLoginNavigation(tokenTemp ? 0 : loginNavigation - 1)
                }
              >
                <IconBack />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          {loginNavigation === 0 || loginNavigation === 1 ? (
            <Box
              display={"flex"}
              gap="26px"
              flexDirection="column"
              justifyContent={"center"}
              alignItems="center"
              width={loginQuery ? "90%" : "53%"}
              height="100%"
            >
              <Box
                display={"flex"}
                flexDirection="column"
                justifyContent="center"
                alignItems={"center"}
                height="100px"
                width="100%"
                gap="25px"
              >
                <Box
                  display={"flex"}
                  width="76px"
                  justifyContent="center"
                  height="60px"
                >
                  <img
                    onClick={() =>
                      window.open("https://mindamigo.com/", "_blank")
                    }
                    style={{ cursor: "pointer" }}
                    width={"100%"}
                    height="100%"
                    src={require("../../../assets/images/logo.png")}
                    alt="Mindamigo"
                  />
                </Box>
                <Typography
                  fontFamily={font.family.fm_2}
                  color={theme.col_2}
                  textAlign="center"
                  fontSize={font.size.fs_2}
                  fontWeight="bold"
                >
                  {loginNavigation === 0
                    ? " Sign in to Mindamigo"
                    : "Verify OTP"}
                </Typography>
              </Box>
              {loginNavigation === 0 ? (
                <>
                  <Box
                    display="flex"
                    width="100%"
                    flexDirection="column"
                    gap="12px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      display="flex"
                      width="100%"
                      flexDirection={loginQuery ? "column" : "flex"}
                      gap="16px"
                      justifyContent="center"
                    >
                      <TextFieldMA
                        required
                        error={
                          email === null
                            ? false
                            : !validator.isEmail(email) && email !== ""
                            ? true
                            : email === ""
                            ? true
                            : false
                        }
                        helperText={
                          email === null
                            ? ""
                            : !validator.isEmail(email) && email !== ""
                            ? "Enter valid email"
                            : email === ""
                            ? "Email is required"
                            : ""
                        }
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyUp={handleEnter}
                        fullWidth
                        label="Email"
                      />
                      <TextFieldMA
                        required
                        error={
                          password === null
                            ? false
                            : !validator.isStrongPassword(password) &&
                              password !== ""
                            ? true
                            : password === ""
                            ? true
                            : false
                        }
                        helperText={
                          password === null
                            ? ""
                            : !validator.isStrongPassword(password) &&
                              password !== ""
                            ? "Password at least 8 characters long. A combination of uppercase letters, lowercase letters, numbers, and symbols *"
                            : password === ""
                            ? "Password is required"
                            : ""
                        }
                        onChange={(e) => {setPassword(e.target.value)}}
                        onKeyUp={handleEnter}
                        type={visibility ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setVisiblity(!visibility)}
                              >
                                {visibility ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                        label="Password"
                      />
                    </Box>
                    <Box
                      display="flex"
                      width="100%"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        color={theme.col_2}
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate("/forgot-password")}
                      >
                        Forgot password
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={"column"}
                    width="100%"
                    gap="16px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <ButtonCustom
                    id='enterButton'
                      onClick={handleSignin}
                      fullWidth={true}
                      disabled={loaderStateApi}
                      loaderState={loaderStateApi}
                      borderRadius="42px"
                      size="large"
                      background={theme.col_2}
                      backgroundRipple={theme.col_3}
                      focusColor={theme.col_1}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      typography={
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_4}
                        >
                          SIGN IN
                        </Typography>
                      }
                    />

                    <Typography
                      fontFamily={font.family.fm_2}
                      color={theme.txtAlpha}
                      textAlign="center"
                      fontSize={font.size.fs_4}
                      fontWeight="bold"
                      display={"flex"}
                      alignItems="center"
                      gap="5px"
                    >
                      Don't have an account?{" "}
                      <Typography
                        fontFamily={font.family.fm_2}
                        onClick={() => navigate("/signup")}
                        sx={{
                          "&:hover": { textDecoration: "underline" },
                          cursor: "pointer",
                        }}
                        color={theme.col_3}
                        textAlign="center"
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                      >
                        Create an account
                      </Typography>
                    </Typography>
                  </Box>{" "}
                </>
              ) : (
                <>
                  <VerifyOtp
                    loaderState={loaderState}
                    setLoaderState={setLoaderState}
                    loginQuery={loginQuery}
                    email={email}
                    setLoginNavigation={setLoginNavigation}
                  />
                </>
              )}
            </Box>
          ) : (
            <>
              <LoginNav
                loaderState={loaderState}
                setLoaderState={setLoaderState}
                setSignInSnack={setSignInSnack}
                setError={setError}
                loginQuery={loginQuery}
                email={email}
                setLoginNavigation={setLoginNavigation}
                loginNavigation={loginNavigation}
              />
            </>
          )}
          {loaderState ? <GlobalLoaders /> : <></>}
        </Box>
      </Box>
      <GlobalSnackBar open={signInSnack} title={error} close={setSignInSnack} />
    </>
  );
};

const LoginNav = ({
  loginNavigation,
  loginQuery,
  email,
  setLoginNavigation,
  setSignInSnack,
  setError,
  loaderState,
  setLoaderState,
}) => {
  console.log(loginNavigation, "navCompo");
  switch (loginNavigation) {
    case 1:
      return (
        <VerifyOtp
          loaderState={loaderState}
          setLoaderState={setLoaderState}
          loginQuery={loginQuery}
          email={email}
          signInSnack={setSignInSnack}
          setError={setError}
          setLoginNavigation={setLoginNavigation}
        />
      );
    case 2:
      return (
        <CompanyProfile
          setSignInSnack={setSignInSnack}
          setError={setError}
          loginQuery={loginQuery}
          email={email}
          setLoginNavigation={setLoginNavigation}
        />
      );
    case 3:
      return (
        <Subscriptions
          setSignInSnack={setSignInSnack}
          setError={setError}
          loginQuery={loginQuery}
          email={email}
          setLoginNavigation={setLoginNavigation}
        />
      );
    case 4:
      return (
        <StripePayment
          setSignInSnack={setSignInSnack}
          setError={setError}
          loginQuery={loginQuery}
          email={email}
          setLoginNavigation={setLoginNavigation}
        />
      );
    default:
      return;
  }
};
